import React from "react";
import { EstablishmentValenceCard } from "./establishment_valence_card.component";
import getDistance from "geolib/es/getDistance";
import Typography from "@material-ui/core/Typography";

export const EstablishmentValencesCard = ({
  establishmentValences,
  addEstablishmentValence,
  disperseRequest,
  limit = 250,
  filters = {},
  localidade_parish,
  localidade_county,
  nrAutoAddedEstablishments,
  countAllAutoAddedEstablishments,
  countAutoNotSentEstablishments,
  countManualAddedEstablishments,
  countManualNotSentEstablishments,
  isNameFilterEnabled,
  visitTime,
  admissionDate,
  monthlyPayment,
  userRequest,
}) => {
  const establishmentValencesCount = establishmentValences.length;
  const establishmentValencesWithPlanCount = establishmentValences.filter(
    (establishmentValence) => establishmentValence.plan !== "Base"
  ).length;

  let filteredEstablishmentValences = establishmentValences;
  if (filters.map_filter) {
    const {
      map_latitude: latitude,
      map_longitude: longitude,
      map_radius: radiusInMeters,
    } = filters;
    filteredEstablishmentValences = filteredEstablishmentValences.filter(
      (establishmentValence) => {
        const { latitude: lat1, longitude: lon1 } =
          establishmentValence.establishment;
        if (!lat1 || !lon1 || !latitude || !longitude) {
          return false;
        }
        return (
          getDistance(
            { latitude, longitude },
            { latitude: lat1, longitude: lon1 }
          ) <= radiusInMeters
        );
      }
    );
  }

  let limitedEstablishmentValences = filteredEstablishmentValences.slice(
    0,
    limit
  );
  //console.log("parish: "+localidade_parish,"county: "+localidade_county,"filtro: "+filters.map_filter)
  if (localidade_parish != null && localidade_county != null) {
    return (
      <>
        {!disperseRequest && (
          <div className="container">
            {limitedEstablishmentValences.length === 0 && (
              <Typography variant="subtitle2" style={{ textAlign: "center" }}>
                Sem mais resultados para os critérios definidos
              </Typography>
            )}
            {limitedEstablishmentValences.map((establishmentValence) => (
              <EstablishmentValenceCard
                userRequest={userRequest}
                key={establishmentValence.id}
                establishmentValence={establishmentValence}
                addEstablishmentValence={addEstablishmentValence}
                nrAutoAddedEstablishments={nrAutoAddedEstablishments}
                countAllAutoAddedEstablishments={
                  countAllAutoAddedEstablishments
                }
                countAutoNotSentEstablishments={countAutoNotSentEstablishments}
                countManualAddedEstablishments={countManualAddedEstablishments}
                countManualNotSentEstablishments={
                  countManualNotSentEstablishments
                }
                isNameFilterEnabled={isNameFilterEnabled}
                filters={filters}
              />
            ))}
          </div>
        )}
        {disperseRequest && (
          <div className="container">
            {`Equipamentos: ${establishmentValencesCount}`} <br />{" "}
            {`Com Plano Pago: ${establishmentValencesWithPlanCount}`}
          </div>
        )}
      </>
    );
  } else if (filters.map_filter) {
    return (
      <Typography variant="subtitle2" style={{ textAlign: "center" }}>
        Sem mais resultados para os critérios definidos (insira um concelho e
        uma freguesia). O encaminhamento através do mapa não está disponível.
      </Typography>
    );
  } else {
    return (
      <Typography variant="subtitle2" style={{ textAlign: "center" }}>
        Sem mais resultados para os critérios definidos (insira um concelho e
        uma freguesia).
      </Typography>
    );
  }
};
